export type AccessibleStationOption = {
	id: number;
	label: string;
	mntpnt_int: string;
};


export const filterAccessibleStations = (
	stations: readonly AccessibleStationOption[],
	searchQuery: string,
): AccessibleStationOption[] => {
	const query = searchQuery.toLowerCase().trim();
	if (query === '') {
		return [...stations];
	}
	return stations.filter(station => (
		station.label.toLowerCase().includes(query)
		|| station.mntpnt_int.toLowerCase().includes(query)
	));
};
